export const SET_COLLISION_DATA = Symbol('SET_COLLISION_DATA');
export const SET_CURRENT_POSITION = Symbol('SET_CURRENT_POSITION');
